import { render, staticRenderFns } from "./PriceListDetailHeader.vue?vue&type=template&id=2b6720ea"
import script from "./PriceListDetailHeader.vue?vue&type=script&lang=js"
export * from "./PriceListDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./PriceListDetailHeader.vue?vue&type=style&index=0&id=2b6720ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports